var _circle, _g, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRays(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 359,
    height: 448,
    viewBox: "0 0 359 448",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2032_25356",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -108,
    y: -123,
    width: 571,
    height: 571
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 177.3,
    cy: 162.3,
    r: 150,
    stroke: "black",
    strokeWidth: 270.6,
    strokeDasharray: "75.88 75.88"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2032_25356)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -35,
    y: -60,
    width: 417,
    height: 416,
    rx: 208,
    fill: "#EDE9E3"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 154.5,
    cy: 166,
    rx: 393.5,
    ry: 192,
    fill: "url(#paint0_radial_2032_25356)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2032_25356",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(166.834 165.468) rotate(93.6654) scale(192.926 218.247)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F4F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F4F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRays);
export default __webpack_public_path__ + "static/media/Rays.25e2c3ccab8ab5c8011134e2fcbada17.svg";
export { ForwardRef as ReactComponent };